import React from 'react';
import FormSelect from 'components/form/FormSelect';
import { NamePath } from 'antd/es/form/interface';
import { DynamicObjectType } from 'types/commons';
import { upperFirst } from 'lodash';

interface PaymentMethodSelectProps {
  extraProps?: DynamicObjectType;
  name?: NamePath;
}

function PaymentMethodSelect({ name, extraProps }: PaymentMethodSelectProps) {
  return (
    <FormSelect
      {...extraProps}
      name={name}
      rules={[{ required: true, message: 'Missing value' }]}
      reference={{
        model: 'payment-method',
        valueProp: 'name',
        labelFormat: (e) => upperFirst(e?.name || ''),
        initFilters: {
          filters: [
            {
              condition: 'and',
              key: 'isActive',
              operator: 'eq',
              value: true,
            },
          ],
        },
      }}
      className="min-w-[100px]"
      placeholder="Value"
    />
  );
}

export default PaymentMethodSelect;
